import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./index.css"
import { useMobileStatus } from "../../../new/Utils/useMobileStatus";
var moment = require("moment");

const NewDateRangePicker = (props) => {

    const filterData = JSON.parse(localStorage.getItem("filterData"))





    const formateDate = (dateStr) => {
        const [day, month, year] = dateStr.split("/");
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate
    }

    const startingFormatedDate = filterData ? formateDate(filterData.formData.dateRangeValue.startDate) : null
    const endFormatedDate = filterData ? formateDate(filterData.formData.dateRangeValue.endDate) : null






    const [start_date, setStartDate] = useState(startingFormatedDate)
    const [end_date, setEndDate] = useState(endFormatedDate)

    const [dateRange, setDateRange] = useState({
        start_date: startingFormatedDate,
        end_date: endFormatedDate,
    });


    const handleStartDate = (e) => {

        setStartDate(e.target.value)
        setDateRange({ start_date: e.target.value, end_date })

    }
    const handleEndDate = (e) => {

        setEndDate(e.target.value)
        setDateRange({ start_date, end_date: e.target.value })
    }




    useEffect(() => {

        var today = new Date().toISOString().split('T')[0];
        document.getElementsByName("StartDate")[0].setAttribute('max', today);
        document.getElementsByName("EndDate")[0].setAttribute('max', today);

        props.onDateRangeChange(dateRange)
    }, [dateRange])


    useEffect(() => {
 
        if (props.shouldResetOnLocationChange) {
            setStartDate(null);
            setEndDate(null);
            setDateRange({ start_date: null, end_date: null });
        }
    }, [props.location, props.shouldResetOnLocationChange]);


    const isMobile = useMobileStatus();


    return (
        <div className="date-input-container">
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div>
                    <label
                        for="birthday"
                        className="date-input-label-from">
                        From:
                    </label>
                    <input
                        type="date"
                        id="start" name="StartDate"
                        placeholder="Start"
                        className="date-input"
                        style={props.startStatus ? { border: '1px solid red' } : { borderColor: ' border: 1px solid #ccc' }}
                        value={start_date}
                        onChange={handleStartDate}
                        key={start_date}
                    />
                </div>
                {
                    props.startStatus ?
                        <p style={{ display: 'flex', paddingLeft: isMobile?'0px' :'43.9px', color: 'red' }}>Please select start date</p>
                        :
                        <p></p>
                }
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div>
                    <label style={{marginRight:'8px',marginLeft: isMobile ?'0px':'25px'}}
                        for="birthday"
                        >
                        To:
                    </label>
                    <input
                        type="date"
                        id="end"
                        name="EndDate"
                        placeholder="Start"
                        className="date-input"
                        style={props.endStatus ? { border: '1px solid red' } : { borderColor: ' border: 1px solid #ccc' }}
                        value={end_date}
                        onChange={handleEndDate}
                        key={end_date}

                    />
                </div>
                {
                    props.endStatus ?
                        <p style={{ display: 'flex', paddingLeft:isMobile?'0px': '49.9px', color: 'red' }}>Please select end date</p>
                        :
                        <p></p>
                }
            </div>
            <div >


            </div>
        </div>
    );
};

export default withRouter(NewDateRangePicker);


// WEBPACK FOOTER //
// ./src/_components/common/NewDateRangePicker/index.jsx